import { number as r } from "./atoms-v21098.js";
const t = {
  ...r,
  transform: Math.round
};
export {
  t as int
};
